<template>
  <div>
    <el-button
      type="primary"
      icon="el-icon-plus"
      circle
      @click="addGoods"
      v-if="!readonly"
      style="float:right;margin:10px 15px 10px 0;"
    ></el-button>
    <el-divider>供应商</el-divider>
    <el-table ref="list" border :data="tableData" style="width: 100%">
      <el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
      <!-- <el-table-column prop="GoodsName" label="商品名称" /> -->
      <el-table-column label="供应商" min-width="150px" prop="SupplierName" />
      <el-table-column label="操作" align="center" fixed="right" width="130px" v-if="!readonly">
        <template slot-scope="{ row,$index }">
          <el-link icon="el-icon-delete" @click.stop="del(row,$index)" :underline="false">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <el-divider></el-divider>
    <supplier-dialog
      ref="supplierDialog"
      in-dialog
      selectable
      multiple
      @select-multiple="setSupplier"
    />
  </div>
</template>
<script>
import accountSelect from "@/components/sales/business/select";
import unitSelect from "@/components/basicinfo/goods/unit/select";
import supplierDialog from "@/components/purchase/supplier/archives/listDialog";
export default {
  props: {
    info: {},
    readonly: {
      type: Boolean,
      default: false,
    },
    showTax: {
      type: Number,
      default: 0,
    },
  },
  components: {
    accountSelect,
    unitSelect,
    supplierDialog,
  },
  data() {
    return {
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1,
      },
      tableData: [],
      current: null,
      tableDel: [],
      sApi: require("@/api/goods/goods").default,
      api: require("@/api/sale/stInDoc").default,
      saleApi: require("@/api/sale/sales").default,
      account_api: require("@/api/goods/goods").default,
      unit_api: require("@/api/ba/unit").default,
      PriAdjustGoodsList: [],
      DAccount: [],
      initDAccount: [],
      initTotal: 0,
    };
  },
  mounted() {
    this.account_api
      .list({ Status: 1, pageIndex: 1, pageSize: 7 })
      .then((res) => {
        if (res.Code == 0)
          (this.DAccount = res.Data),
            (this.initDAccount = res.Data),
            (this.initTotal = res.Count);
      });
  },
  methods: {
    setSupplier(data) {
      console.log(data);
      // this.tableData=[]
      data.forEach((e) => {
        this.tableData.push({
          GoodsSupplierId: 0,
          GoodsId: this.info.GoodsId,
          T: 0,
          SupplierId: e.TradeUnitId,
          SupplierName: e.TradeUnitName,
        });
      });
      // this.tableData.GoodsSupplierIds = data.map((x) => x.TradeUnitId);
      // this.tableData.GoodsSupplierNames = data.map((x) => x.TradeUnitName).join("；");
    },
    onChange(row) {
      this.tableData.forEach((x) => {
        x.T = x.T == 0 ? 0 : 1;
        x.IsMain = false;
      });
      row.IsMain = true;
      row.Rate = 1;
    },
    resetFun() {
      this.pageParams.pageIndex = 1;
      this.DAccount = this.initDAccount;
      this.listTotal = this.initTotal;
    },
    currentPage(val) {
      this.pageParams.pageIndex = val;
      this.account_api
        .list({ Status: 1, pageIndex: val, pageSize: 7 })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;

            this.listTotal = res.Count;
          }
        });
    },
    inputText(text) {
      this.account_api
        .list({ Status: 1, pageIndex: 1, pageSize: 7, GoodsName: text })
        .then((res) => {
          if (res.Code == 0) {
            this.DAccount = res.Data;

            this.listTotal = res.Count;
          }
        });
    },
    validateCounts(row, index, e, name) {
      e.target.blur(); // 或者this.$refs[row.id].blur()
      this.$refs[Object.keys(this.$refs)[index + 1] + name].focus();
    },
    getData() {
      // this.tableData = [];
      this.tableData = this.info.GoodsSuppliers;
      // this.saleApi.getGoodsList(this.info.OrderId).then((res) => {
      //   this.tableData = res.Data;
      // });
    },
    del(row, index) {
      this.$confirm("确认删除该行数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        if (row.T !== 0) {
          row.T = 2;
          this.tableDel.push(row);
        }
        if (this.tableData.length == 1) {
          this.tableData.splice(index, 1);
          this.addGoods();
        } else {
          this.tableData.splice(index, 1);
        }
        this.subTable();
      });
    },
    addGoods() {
      let ids = this.tableData.map((x) => x.GoodsSupplierId);
      this.$refs.supplierDialog.open().then((that) => {
        that.getData({ NotIds: ids });
        that.getTree();
      });
    },
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0;
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null;
    },
    changeNum(row) {
      // row.Quantity = Math.floor(row.Quantity)
      this.count(row);
    },
    rateChange(row) {
      this.count(row);
    },
    disChange(row) {
      this.count(row);
    },
    count(row) {
      if (row.T !== 0) row.T = 1;
      this.subTable();
    },
    subTable() {
      this.$emit("getList", this.tableData.concat(this.tableDel));
    },
    clear() {
      this.tableData = [];
      this.tableDel = [];
    },
  },
};
</script>

<style>
.el-link {
  font-size: 14px;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
</style>